import { useState } from "react";
import "./toggle-switch.scss";

interface ToggleSwitchProps {
  activeStatusText: string;
  inActiveStatusText: string;
  value: boolean;
  externalSwitchClasses?: string;
  onChange?: (status: boolean) => void;
  isDisabled?: boolean;
}

const ToggleSwitch = ({
  activeStatusText,
  inActiveStatusText,
  value,
  externalSwitchClasses = "",
  onChange,
  isDisabled,
}: ToggleSwitchProps) => {
  const [isActive, setIsActive] = useState(value);

  const handleToggle = () => {
    setIsActive((current) => {
      if (onChange) {
        onChange(!current);
      }

      return !current;
    });
  };

  return (
    <div
      className={`toggle-switch ${isActive ? "active" : "inactive"} ${externalSwitchClasses} ${isDisabled && "cursor-default"} ${isActive ? "justify-content-start" : "justify-content-end"}`}
      onClick={!isDisabled ? handleToggle : () => {}}
    >
      <div className="switch-handle" />
      <span className={`switch-text ${isActive ? "ps-3" : "pe-2"}`}>
        {isActive ? activeStatusText : inActiveStatusText}
      </span>
    </div>
  );
};

export default ToggleSwitch;
